import styled from "styled-components";

export const NavigationStepsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-pack: center;
  justify-content: space-between;
  gap: 12px; // space-between still needs a gap if the elements squish together
  width: 100%;
  min-height: 43px;
  flex-shrink: 0;
  background-color: var(--primary-dark-600);
  color: var(--primary-white);
  padding: 8px 40px;
  align-items: center;
`;

export const Step = styled.span`
  color: var(--primary-dark-200);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 400;
  line-height: var(--lh-base);
  white-space: nowrap;
`;

export const JobTitleInput = styled.input`
  color: var(--primary-white);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 600;
  line-height: var(--lh-base);
  border: none;
  background-color: var(--primary-dark-500);
  outline: none;
  padding: 3px 10px;
  border-radius: 5px;
  width: 250px;
`;

export const SaveJobTitleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  position: absolute;
  right: 5px;
  top: 2.5px;
  background-color: var(--primary-blue);
  border-radius: 3px;
`;

export const JobTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }

  svg {
    flex-shrink: 0;
  }
`;

export const JobTitle = styled.span`
  color: var(--primary-white);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 600;
  line-height: var(--lh-base);
`;

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const StepJobTitleContainer = styled(StepsContainer)`
  min-width: 340px;
`;

export const NavigationStepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  margin-left: 50px;

  @media screen and (width < 1200px) {
    margin-left: 6px;
  }
`;

export const NavigationStepsButton = styled.button`
  display: flex;
  padding: 6px 12px 6px 9px;
  align-items: center;
  gap: 5px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  color: ${({ isActive }) => (isActive ? "var(--primary-white)" : "var(--primary-blue-300)")};
  font-weight: 500;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  background-color: var(--primary-dark-500);

  @media screen and (width < 1100px) {
    span {
      display: none;
    }
  }
`;

export const EditBasicInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
`;

export const EditBasicInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.02);
  }
`;

export const EditBasicInfoText = styled.span`
  color: var(--primary-white);
  font-size: var(--fs-base);
  font-style: normal;
  font-weight: 600;
  line-height: var(--lh-base);
  white-space: nowrap;
`;
